import script from "./RemunerationDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemunerationDetail.vue?vue&type=script&setup=true&lang=ts"

import "./RemunerationDetail.vue?vue&type=style&index=0&id=5bb5dfbe&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb5dfbe"]])

export default __exports__